import { render, staticRenderFns } from "./DiamondList.vue?vue&type=template&id=d7f22a7c&scoped=true&"
import script from "./DiamondList.vue?vue&type=script&lang=js&"
export * from "./DiamondList.vue?vue&type=script&lang=js&"
import style0 from "./DiamondList.vue?vue&type=style&index=0&id=d7f22a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f22a7c",
  null
  
)

export default component.exports